<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>添加轮播banner</h3>
                </el-col>
            </el-row>
        </div>
        <el-form :model="bannerForm">
            <el-form-item label="上传banner图" label-width="100px">
                <el-upload class="avatar-uploader" action="https://upload.qiniup.com/" :show-file-list="false" :on-success="handleAvatarSuccess" :on-error="handleError" :before-upload="beforeAvatarUpload" :data="uptoken">
                    <img v-if="imageUrl" :src="imageUrl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>
            <el-form-item label="跳转类型选择" label-width="100px">
                <el-radio-group v-model="bannerForm.type" @change="typeChange">
                    <el-radio label="商品类型"></el-radio>
                    <el-radio label="商品"></el-radio>
                    <el-radio label="商品标签"></el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="已选商品类型" label-width="100px" v-if="bannerForm.type === '商品类型'">
                <el-input v-model="bannerForm.choosedName" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="已选商品" label-width="100px" v-if="bannerForm.type === '商品'">
                <el-input v-model="bannerForm.choosedName" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="已选商品标签" label-width="100px" v-if="bannerForm.type === '商品标签'">
                <el-input v-model="bannerForm.choosedName" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label-width="100px">
                <el-button type="primary" @click="onSubmit">保存</el-button>
                <el-button @click="goBack">取消</el-button>
            </el-form-item>
        </el-form>
    
    
        <el-dialog title="选择分类" v-model="chooseCatogry">
            <el-form :model="cur_categroy">
                <el-form-item label="选择分类" label-width="100px">
                    <el-select v-model="cur_categroy.now" placeholder="分类">
                        <el-option v-for="item in categoryArr" v-if="item.isOnline" :key="item.categoryId" :label="item.name" :value="item.categoryId">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="chooseCatogry = false">取 消</el-button>
                <el-button type="primary" @click="catogryChoose">确 定</el-button>
            </div>
        </el-dialog>
    
        <el-dialog title="选择标签" v-model="chooseTopic">
            <el-form :model="cur_topic">
                <el-form-item label="选择标签" label-width="100px">
                    <el-select v-model="cur_topic.now" placeholder="标签">
                        <el-option v-for="item in topicArr" v-if="item.isOnline" :key="item.tagId" :label="item.name" :value="item.tagId">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="chooseTopic = false">取 消</el-button>
                <el-button type="primary" @click="topicChoose">确 定</el-button>
            </div>
        </el-dialog>
    
        <el-dialog title="选择商品" v-model="chooseProduct">
            <el-form :model="cur_product">
                <el-form-item label="选择商品" label-width="100px">
                    <el-select v-model="cur_product.now" placeholder="商品">
                        <el-option v-for="item in productArr" v-if="item.isOnline" :key="item.productDetailId" :label="item.name" :value="item.productDetailId">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="chooseProduct = false">取 消</el-button>
                <el-button type="primary" @click="productChoose">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        getVersions,
        getGlobalSettings,
        filterIndexVersions,
        getProductCategories,
        getProductTags,
        getProductDetails
    } from '../../api/version'
    
    export default {
        data() {
            return {
                bannerForm: {
                    type: '',
                    choosedName: ''
                },
                choosedName: '',
                imageUrl: '',
                upImage: '',
                type: '',
                targetId: '',
                uptoken: {
                    token: sessionStorage.token
                },
                categoryArr: [],
                topicArr: [],
                productArr: [],
                chooseCatogry: false,
                chooseTopic: false,
                chooseProduct: false,
                cur_categroy: {
                    now: ''
                },
                cur_topic: {
                    now: ''
                },
                cur_product: {
                    now: ''
                }
            }
        },
        created() {
            this.productArr = this.$store.state.topicArr
            this.categoryArr = this.$store.state.categoryArr
            this.topicArr = this.$store.state.productArr
            console.log(this.topicArr,'ff')
        },
        methods: {
            onSubmit() {
                if (!this.targetId) {
                    this.$message.error('您还未选择转换类型具体分类');
                } else if (typeof this.type !== 'number') {
                    this.$message.error('您还未选择图片转换类型');
                } else if (!this.upImage) {
                    this.$message.error('您还未上传banner图片')
                } else {
                    let bannerData = {
                        'picUrl': this.upImage,
                        'type': this.type,
                        'targetId': this.targetId
                    }
                    let currentData = this.$store.state.currentIndex

                    currentData.value.banner.push(bannerData)
                    this.$store.commit('SETCURRENTINDEX', currentData);
                    this.$message({
                        message: '新建成功',
                        type: 'success'
                    });
                    this.$router.push('/banner')
                }
                //         {
                //   "picUrl": "banner1.png",
                //   "type": 0,
                //   "targetId": 1
                // }
            },
            goBack() {
                //取消
                this.$router.push('/banner')
            },
            typeChange(val) {
                // banner的类型	0:分类，1:标签, 2:商品
                if (val === '商品类型') {
                    this.type = 0
                    this.chooseCatogry = true
                } else if (val === '商品') {
                    this.type = 2
                    this.chooseProduct = true
                } else {
                    this.type = 1
                    this.chooseTopic = true
                }
            },
            handleAvatarSuccess(res, file) {
                this.upImage = `https://img.shareplay.cc/${res.key}`
                this.imageUrl = URL.createObjectURL(file.raw);
            },
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2;
                this.uptoken = {
                    token: sessionStorage.token
                }

                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!');
                }
                return isLt2M;
            },
            productChoose() {
                this.targetId = this.cur_product.now
                this.productArr.forEach( item => {
                    if(item.productDetailId === this.targetId){
                        this.bannerForm.choosedName = item.name
                    }
                })
                this.chooseProduct = false
            },
            topicChoose() {
                this.targetId = this.cur_topic.now
                this.topicArr.forEach( item => {
                    if(item.tagId === this.targetId) {
                        this.bannerForm.choosedName = item.name
                    }
                })
                this.chooseTopic = false
            },
            handleError() {
                this.$message.error('请重新登录')
                this.$router.push('/login')
            },
            catogryChoose() {
                this.targetId = this.cur_categroy.now
                this.categoryArr.forEach( item => {
                    if(item.categoryId === this.targetId) {
                        this.bannerForm.choosedName = item.name
                    }
                })
                this.chooseCatogry = false
            }
        }
    }
</script>

<style>
    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>




// WEBPACK FOOTER //
// AddBanner.vue?5a3645ba